import { Box, BoxProps } from "./Box";

export const FlexColBox = (props: BoxProps) => {
  return <Box display="flex" flexDirection="column" {...props} />;
};
